import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import SessionContext from "SessionContext";
import ConfirmSuccess from "../core/ui/confirm-success";
import UnsavedChanges from "partials/unsaved-changes";

function SuppressInvoiceNewForm(props) {
  const history = useHistory();
  const session = useContext(SessionContext);

  const [suppressInvoiceData, setSuppressInvoiceData] = useState();
  const [invoiceCategoryData, setInvoiceCategoryData] = useState();
  const [suppressedList, setSuppressedList] = useState(null);
  const [invoicesList, setInvoicesList] = useState(null);
  const [disableUpdateBtn, setDisableUpdateBtn] = useState(true);
  const [showSuccess, setShowSuccess] = useState(false);

  const getInvoiceList = () => {
    session
      .query("admin/invoice_categories?sort_asc=true&filters=%7B%7D&sort_by=&sort_dir=asc")
      .then((response) => {
        setInvoicesList(response.rows);
      })
  }

  useEffect(() => {
    getInvoiceList();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onClickBack() {
    history.push("/admin-suppress-invoice-category");
  }

  function onSelectSuppression(_id) {
    let new_selection = {};
    suppressedList.forEach((val) => {
      if(val.id.toString() === _id.toString()) {
        new_selection = {...val};
      }
    });
    setSuppressInvoiceData(new_selection);
  }

  const getInvoiceSuppressionList = () => {
    session
      .query("admin/get_suppression_invoice_category", { id: invoiceCategoryData.id })
      .then((response) => {
        setSuppressedList(response);
      })
      .catch((error) => {
        console.log("Failed to Load Suppressed Invoice Category List", JSON.stringify(error));
      })

  }

  function onSelectInvoice(_id) {
    let new_selection = {};
    invoicesList.forEach((val) => {
      if(val.id.toString() === _id.toString()) {
        new_selection = {...val};
      }
    });
    setInvoiceCategoryData(new_selection);
  }

  function onClickSave() {
    let updatedData = {am_invoice_category: invoiceCategoryData, suppressed_am_invoice_category: suppressInvoiceData}
    session.command('admin/create_invoice_category_suppression', updatedData, {}, { defaultErrorHandling: false })
    .then(() => {
      setShowSuccess(true);
      setDisableUpdateBtn(true);
      setTimeout(() => {
        onClickBack();
      }, 2000);
    })
    .catch((err) => {
      console.log("Suppressed Invoice Category Create Failed", err)
    })
    
  }

  useEffect(() => {
    if(suppressInvoiceData && invoiceCategoryData) {
      if("id" in invoiceCategoryData && "id" in suppressInvoiceData) {
        setDisableUpdateBtn(false);
      } else {
        setDisableUpdateBtn(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suppressInvoiceData, invoiceCategoryData])

  useEffect(() => {
    if(invoiceCategoryData) {
      getInvoiceSuppressionList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceCategoryData])

  return (
    <div className="page admin-page suppress-categories-page">
        <div className="list-header sticky-page-header">
          <button className="new-button" onClick={onClickBack}>
            <i className="bi bi-chevron-left"></i> Back
          </button>
          <h1>New Suppressed Invoice</h1>
          <i className="spacer" />
          <button className="new-button promote" disabled={disableUpdateBtn} onClick={onClickSave}>
            Save
          </button>
        </div>
        <div className="m-5 suppress-main">
          <div className="mx-3">
            <h5>Invoice Category</h5>
            <div className="card-border">
              {invoiceCategoryData ? (<>
                <div className="my-1">Name: <strong>{invoiceCategoryData.name}</strong></div>
                <div className="my-1">Description: <strong>{invoiceCategoryData.description}</strong></div>
                <div className="my-1">Unit Price: <strong>{invoiceCategoryData.unit_price}</strong></div>
                <div className="my-1">Channel Options: <DisplayChannelOptions _list={invoiceCategoryData.channel_options} /></div>
              </>) : <div>Select an option below.</div>
              }
            </div>
          </div>

          <div className="mx-3">
            <h5>Suppressed Invoice Category</h5>
            <div className="card-border">
              {suppressInvoiceData ? (<>
                <div className="my-1">Name: <strong>{suppressInvoiceData.name}</strong></div>
                <div className="my-1">Description: <strong>{suppressInvoiceData.description}</strong></div>
                <div className="my-1">Unit Price: <strong>{suppressInvoiceData.unit_price}</strong></div>
                <div className="my-1">Channel Options: <DisplayChannelOptions _list={suppressInvoiceData.channel_options} /></div>
              </>) : <div>Select an option below.</div>
              }
            </div>
          </div>
        </div>

        <div className="m-5 suppress-main">
          <div className="mx-3">
            <h5>Select Invoice Category</h5>
            <div className="card-border-new">
              <select defaultValue="" onChange={(e) => onSelectInvoice(e.target.value)}>
                <option value="" disabled>Select a value</option>
                {invoicesList && invoicesList.map((option) => (
                  <option key={option.id} value={option.id}>
                    {`${option.name} - ${option.description}: $(${option.unit_price})`}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="mx-3">
            <h5>Select Suppressed Invoice Category</h5>
            <div className="card-border-new">
              {suppressedList ? <select defaultValue="" onChange={(e) => onSelectSuppression(e.target.value)}>
                <option value="" disabled>Select a value</option>
                {suppressedList.map((option) => (
                  <option key={option.id} value={option.id}>
                    {`${option.name} - ${option.description}: $(${option.unit_price})`}
                  </option>
                ))}
              </select> : <div>Select a Invoice Category to begin.</div>}
            </div>
          </div>
        </div>
        <ConfirmSuccess show={showSuccess} label="Suppressed Invoice Created." />
        <UnsavedChanges hasUnsavedChanges={!disableUpdateBtn} />
    </div>
  )
}

export default SuppressInvoiceNewForm;

/* Format and display channels options */
export function DisplayChannelOptions({_list}) {

  if(_list && _list.length) {
    return (<ul>
      <strong>{
        _list.map((channel) => {
          return <li key={channel.id}><span>{channel.name}</span><br /></li>
        })
      }</strong>
    </ul>)
  }

  return <span><strong>None</strong></span>;
}